import type { ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { ErrorFallback } from '../ErrorFallback'

/**
 * PageErrorBoundary — rede de segurança por página.
 *
 * Contém crashes de uma rota (ex.: o desync React×DOM ao desmontar diálogos,
 * disparado por tradução automática) em um fallback local, em vez de derrubar o
 * app inteiro (tela branca do ErrorBoundary do root em main.tsx).
 *
 * O reset recarrega a página: garante DOM limpo caso a tradução/extensão tenha
 * mexido na árvore. Camada complementar ao patch global (translateCrashGuard).
 * Ver docs/removechild-translate-crash.md
 */
export function PageErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => window.location.reload()}
    >
      {children}
    </ErrorBoundary>
  )
}
